import { twMerge } from "@/utils/twMerge";

import type { ReactNode } from "react";

export const Title = ({ value, className }: { value: ReactNode; className?: string }) => {
  return (
    <h2
      className={twMerge(
        "m-0 mb-2 p-0 font-geist font-bold text-[46px] leading-[44px] tracking-tighter break-words",
        className,
      )}
    >
      {value}
    </h2>
  );
};
